import React, { useEffect, useState } from 'react';
import call from "../../../service";
import { connect } from "react-redux";
import { setFinanceDetails, setChannelPartnerRaisedInvoice } from '../../../store/actions/action';
import toastDisplay from "../../../utils/toastNotification";
import toolTipText from '../../../utils/toolTips/financeForm.json'
import { formatDate_Application, dateFormatter_DatePicker } from '../../../utils/dateFormaters';
import FilePreview from '../../utilComponents/previewFile';
import DigitalSignDoc from '../../contractDocument/digitalSignDoc2';
import OtherDocs from "./otherDocs";
import validate from '../../../utils/validation_files/LCFinanceValidationRules'
import config from '../../../config.json';
import { ClearCache, convertImageToPdf, GetCache, SetCache } from '../../../utils/myFunctions';


const LCFinance = ({ userTokenDetails, setFinanceDetails, financeDetails, channelPartnerRaisedInvoice, setChannelPartnerRaisedInvoice, dispatch }) => {

  let cache_data = financeDetails.info.action === "applyFinance" ? GetCache("lc_form_data") : {}

  //---------------------------------------------------------------------------------------------------------------------
  // Const State and their handlers declaration and initiation.
  const [bankMaster, setbankMasters] = useState([]);
  const [buyerArr, setBuyerArr] = useState([]);
  const [buyerType, setBuyerType] = useState(cache_data["buyerType"] || 1);
  const [logiArr, setLogiArr] = useState([]);
  const [currencyData, setcurrencyData] = useState([]);
  const [data, setData] = useState(cache_data["data"] || {});
  const [file, setFile] = useState({});
  const [error, setError] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [amount, setAmount] = useState(0);
  const [fileData, setfileData] = useState({});
  const [refresh, setrefresh] = useState(0);
  const [showPreviewModal, setshowPreviewModal] = useState(false);
  const [showAclAuthModal, setAclAuthModal] = useState(false);
  const [showLoader, setshowLoader] = useState(false);
  const [creditData, setCreditData] = useState([]);
  const [counterPart, setCounterPart] = useState([]);
  const [accord, setAccord] = useState({
    0: false
  });
  const [tab, setTab] = useState(0)

  const userTypeId = userTokenDetails.type_id ? userTokenDetails.type_id : null
  const userEmail = userTokenDetails.email ? userTokenDetails.email : null
  const userId = userTokenDetails.user_id ? userTokenDetails.user_id : null
  const userName = userTokenDetails.userName ? userTokenDetails.userName : null
  const astrix = <span className="required-field text-danger">*</span>
  //---------------------------------------------------------------------------------------------------------------------


  //---------------------------------------------------------------------------------------------------------------------
  // UseEffects
  useEffect(() => {
    setAclAuthModal(false)

    if (financeDetails.info.tab) {
      setTab(financeDetails.info.tab)
    }

    if (financeDetails.info.action === "viewFinance") {
      setshowLoader(true)
      call('POST', 'getDiscounting', { id: financeDetails.info.FinanceID, type: financeDetails.type }).then((result) => {
        console.log('LC Get Discounting API =====>', result);

        let poDbData = {
          id: result.id,
          referenceNo: result.lc_number,
          buyerId: result.buyer / 1 === 0 ? "ME" : result.buyer,
          sellerId: result.seller,
          sellerName: result.sellerName,
          lenderName: result.lenderName,
          applicantEmail: result.sellerName,
          buyerName: result.buyer / 1 === 0 ? "Other" : result.buyerName,
          buyerEmail: result.buyer / 1 === 0 ? "other_buyer" : result.buyerEmail,
          reqAmount: result.amount,
          contractAmount: result.contract_amount,
          currency: result.currency,
          currencyName: result.amountCurrencyName,
          issueDate: result.lc_issue_date ? dateFormatter_DatePicker(result.lc_issue_date) : "",
          grnDate: result.grn_date ? dateFormatter_DatePicker(result.grn_date) : "",
          creditDays: result.credit_days,
          interestRate: result.interest_rate,
          lenderId: result.lender,
          status: result.status,
          sellerStatus: result.seller_status,
          lenderStatus: result.lender_status,
          type: result.type,
          doc: result.docData.docList,
          exhibitDocList: result.docData.exhibitDocList,
          exhibitStatus: result.exhibit_sign_status,
          NOADocList: result.docData.NOADocList,
          advisingBank: result.advisingBank,
          confirmingBank: result.confirmingBank,
          dueDate: result.dueDate,
          frameworkDocList: result.docData.frameworkDocList,
          logisticId: result.logistics === null ? "NULL" : result.logistics,
          logisticName: result.shipperName === null ? "Not Available" : result.shipperName,
          dnc: "on",
          fintnc: result.fin_tnc,
          buyerNameManual: result.offline_data.buyer_name,
          // buyerAddrManual: result.offline_data.buyer_addr,
          logisticNameManual: result.offline_data.logistic_name
        }

        setBuyerArr([{
          id: result.buyer,
          company_name: result.buyerName
        }])
        setBuyerType(result.offline_data.buyer_type ? result.offline_data.buyer_type : 1)
        setbankMasters([{
          id: result.lender,
          company_name: result.lenderName
        }]);

        setAccord({
          0: true
        })

        setAmount(result.amount)
        setData({ ...poDbData, userId: userId })
        setshowLoader(false)
      }).catch((e) => {
        setshowLoader(false)
        console.log('error in getDiscounting', e);
      })

    } else {
      setData({ ...data, userId: userId, applicantEmail: userEmail });
    }

    // Get currency list from Master table.
    call("get", "getcurrencylist").then((result) => {
      setcurrencyData(result);
    }).catch((e) => {
      console.log("error in getcurrencylist", e);
    });

    if (financeDetails.info.action === "applyFinance") {

      // Get bank master list that are involved in trade finance.
      call("GET", "getBanksListMaster")
        .then((result) => {
          setbankMasters(result);
        })
        .catch((e) => {
          console.log("Error while querying getBanksListMaster:", e);
        });

      call('POST', 'getUsersListing', { "searchUserType": 5, "searchKey": '', "network": "innetwork", "userAvatars": false })
        .then((result) => {
          // console.log("result====>", result)
          setLogiArr([...result]);
        })
        .catch((e) => {
          console.log("error in getcurrencylist", e);
        });

      call('POST', 'getUsersListing', { "searchUserType": 10, "searchKey": '', "network": "innetwork", "userAvatars": false })
        .then((result) => {
          // console.log("result====>", result)
          setLogiArr([...result]);
        })
        .catch((e) => {
          console.log("error in getcurrencylist", e);
        });
    }

    let objectAPI = {
      "manualUserId": userId,
      "userTypeId": userTypeId,
      "userId": userId,
      "gridType": "userapproved"
    }

    objectAPI = { ...objectAPI }


    call('POST', 'getCreditLineByType', objectAPI).then((result) => {
      console.log('running getCreditLineByType api-->', result);
      setCreditData(result.finData);
    }).catch((e) => {
      console.log('error in getCreditLineByType', e);
    })

    let buyerObjectAPI = {
      "userId": userId,
      "userTypeId": userTypeId
    }

    buyerObjectAPI = { ...buyerObjectAPI }

    call('POST', 'getBuyersDetail', buyerObjectAPI).then((result) => {
      console.log('running getBuyersDetail api -->', result.buyerData);
      setCounterPart(result.buyerData);
    }).catch((e) => {
      console.log('error in getBuyersDetail', e);
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);

  useEffect(() => {
    if (financeDetails.info.action === "applyFinance") {
      SetCache('lc_form_data', { data, buyerType })
    }
  }, [data, buyerType])

  useEffect(() => {
    if (financeDetails.info.action === "applyFinance") {

      if (buyerType === 1) {
        call('POST', 'getUsersListing', { "searchUserType": 3, "searchKey": '', "network": "innetwork", "userAvatars": false })
          .then((result) => {
            console.log("result in getUsersListing", result);
            setBuyerArr(result);
            setshowLoader(false)
          })
          .catch((e) => {
            console.log("error in getUsersListing", e);
          });
      } else if (buyerType === 2) {
        call('POST', 'getuserdirectorybytype', { "searchUserType": 3, "searchKey": '' })
          .then((result) => {
            console.log("result in getuserdirectorybytype", result);
            setBuyerArr(result);
            setshowLoader(false)

          })
          .catch((e) => {
            console.log("error in getUsersListing", e);
          });
      }
    }
  }, [buyerType]);

  useEffect(() => {
    if (Object.keys(error).length === 0 && isSubmitting) {
      if (tab === 0) {
        setTab(1)
      }
      else {
        setTab(0)
        forward()
      }
    } else if (isSubmitting) {
      setIsSubmitting(false)
      toastDisplay("Form Validation Error", "warn")
    }
  }, [error]);
  //---------------------------------------------------------------------------------------------------------------------


  //---------------------------------------------------------------------------------------------------------------------
  // console.log("data====>", data)
  // console.log("financeDetails====>", financeDetails)
  // console.log("error====>", error)
  // console.log("logiarray====>", logiArr)
  //---------------------------------------------------------------------------------------------------------------------


  //---------------------------------------------------------------------------------------------------------------------
  const handleChange = (event) => {
    event.persist();

    if (event.target.name === "buyerId") {
      let val = event.target.value.split(':');
      setData({ ...data, [event.target.name]: (val[0] === "ME" ? val[0] : +val[0]), buyerName: val[1], buyerEmail: val[2] });
      setError({ ...error, [event.target.name]: "" });
    } else if (event.target.name === "currency") {
      let val = event.target.value.split(':');
      setData({ ...data, [event.target.name]: val[0], currencyName: val[1] });
      setError({ ...error, [event.target.name]: "" });
    } else if (event.target.name === "lenderId") {
      let val = event.target.value.split(':');
      setData({ ...data, [event.target.name]: +val[0], lenderName: val[1], lenderUniqueId: val[2] });
      setError({ ...error, [event.target.name]: "" });
    } else if (event.target.name === "logisticId") {
      let val = event.target.value.split(':');
      setData({ ...data, [event.target.name]: +val[0], logisticName: val[1] });
      setError({ ...error, [event.target.name]: "" });
    } else if (event.target.name === "dnc") {
      if (data.dnc === "on") {
        setData({ ...data, "dnc": "" });
      } else {
        setData({ ...data, [event.target.name]: event.target.value });
      }
    } else {
      setData({ ...data, [event.target.name]: event.target.value });
      setError({ ...error, [event.target.name]: "" });
    }
  };

  const handleFiles = (event) => {
    event.persist();
    let file_type = event.target.files[0]["type"].toLowerCase()
    if (!((file_type.includes("pdf")) || (file_type.includes("png")) || (file_type.includes("jpeg")))) {
      toastDisplay('Files with pdf, png & jpeg extension are allowed', 'info')
      return
    }
    let reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onloadend = async (e) => {
      let fileObj = event.target.files[0]
      let fileDataUrl = e.target.result
      if (!file_type.includes("pdf")) {
        let response = await convertImageToPdf(fileDataUrl, event.target.files[0]["name"]);
        fileObj = response["file"]
        fileDataUrl = response['dataUrl']
        toastDisplay("File converted into pdf format", "success")
        // console.log("response==>", response);
      }
      setFile({ ...file, [event.target.name]: fileObj });
      setError({ ...error, [event.target.name]: "" });
    }
  };

  const prehandleForward = (event) => {
    if (event) event.preventDefault();
    setError(validate(data, file, financeDetails, userTypeId, tab));
    setIsSubmitting(true);
  };
  //---------------------------------------------------------------------------------------------------------------------


  //---------------------------------------------------------------------------------------------------------------------
  //Functions

  // Handler for next button.
  function forward() {
    setFinanceDetails(financeDetails.status, financeDetails.type, (financeDetails.page / 1) + 1, financeDetails.info)
  }

  // Handler for back button.
  function backward() {
    if (financeDetails.page === 1) {
      if (financeDetails.info.action === "viewFinance") {
        if (userTypeId == 20) {
          setChannelPartnerRaisedInvoice(false, {})
        }
        setFinanceDetails(false, 0, 0, {})
      } else {
        setFinanceDetails(financeDetails.status, 0, 0, financeDetails.info)
      }
    } else if (financeDetails.page === 2 && financeDetails.info.sellerStatus === 2 && financeDetails.info.lenderStatus === 2) {
      setFinanceDetails(false, 0, 0, {})
    } else {
      setFinanceDetails(financeDetails.status, financeDetails.type, (financeDetails.page / 1) - 1, financeDetails.info)
      setIsSubmitting(false)

    }
  }

  function docPreviewGenerator(doc) {
    let docElements = doc.length ? doc.map((values, index) => {
      // console.log("value in doc render=>", values)
      values.tbl_doc_id = values.id
      values.document_name = values.doc_name
      values.uploaded_by = values.createdBy
      values.uploaded_on = values.created_at
      values.signType = 'withoutBlockChain'

      return (<tr>
        <td>{index + 1}</td>
        <td>{(values && values.document_name) ? values.document_name : values.name ? values.name : 'NA'}</td>
        <td>{(values && values.doc_no) ? values.doc_no : 'NA'}</td>
        <td>{(values && values.createdBy) ? values.createdBy : 'NA'}</td>
        <td>{(values && values.created_at) ? formatDate_Application(values.created_at) : 'NA'}</td>
        <td>
          {(values && values.sign) ? <pre><span className="text-success mr-1">{values.sign.map((signV) => { return (<><i className="fa fa-certificate" /> {signV}<br /></>) })}</span></pre> : ''}
        </td>
        <td className="row justify-content-center  mt-0 pt-0 m-0 ">

          <button title="View File" className="text-center btn btn-primary btn-sm m-1" onClick={
            () => callPreviewFileComponent(values, "view")}>
            <i className="fa fa-eye" aria-hidden="true"></i>
          </button>
          <button title="Download File" className="text-center btn btn-primary btn-sm m-1" onClick={
            () => callPreviewFileComponent(values, "download")}>
            <i className="fa fa-download" aria-hidden="true"></i>
          </button>
          <button
            disabled={values.signByUserId && values.signByUserId.length && values.signByUserId.indexOf(userId) != -1}
            title="Authenticate File" className="text-center btn btn-dark btn-sm m-1" onClick={() => callAclAuthComponent(values)}>
            <i class="fas fa-file-signature"></i>
          </button>

        </td>
      </tr>)
    }) : ''
    return (docElements)
  }

  function docUploadPreview(type) {
    return (<tr>
      <td>1</td>
      <td>NA</td>
      <td>NA</td>
      <td>NA</td>
      <td>NA</td>
      <td className="row justify-content-center  mt-0 pt-0 m-0 ">
        <div className="file-browse ">
          <button title="Update File" className="text-center btn btn-success btn-sm m-1">
            <i className="fa fa-upload" aria-hidden="true"></i>
          </button>
          <input type="file" accept=".png,.jpg,.pdf" name={type == 'Exhibit' ? 'ExhibitDocument' : 'NOADocument'} onChange={(event) => updateDocument(event, type)} />
        </div>
      </td>
    </tr>)
  }

  function docAgreementPreview(type) {

    if (type == 'Exhibit') {
      let exhibitDocElements = data.exhibitDocList.length ? data.exhibitDocList.map((values, index) => {
        // console.log("value in doc render =>", values)

        values.reqId = data.id
        values.tbl_doc_id = values.id
        values.document_name = values.doc_name
        values.uploaded_by = values.createdBy
        values.uploaded_on = values.created_at
        values.signType = 'withoutBlockChain'

        return (<tr>
          <td>{1}</td>
          <td>{(values && values.doc_name) ? values.doc_name : 'NA'}</td>
          <td>{(values && values.createdBy) ? values.createdBy : 'NA'}</td>
          <td>{(values && values.created_at) ? formatDate_Application(values.created_at) : 'NA'}</td>
          <td>
            {(values && values.sign) ? <pre><span className="text-success mr-1">{values.sign.map((signV) => { return (<><i className="fa fa-certificate" /> {signV}<br /></>) })}</span></pre> : ''}
          </td>
          <td className="row justify-content-center  mt-0 pt-0 m-0 ">

            <button title="View File" className="text-center btn btn-primary btn-sm m-1" onClick={
              () => callPreviewFileComponent(values, "view")}>
              <i className="fa fa-eye" aria-hidden="true"></i>
            </button>
            <button title="Download File" className="text-center btn btn-primary btn-sm m-1" onClick={
              () => callPreviewFileComponent(values, "download")}>
              <i className="fa fa-download" aria-hidden="true"></i>
            </button>
            {userTypeId == 4 || userTypeId == 14 &&
              <button
                disabled={values.signByUserId && values.signByUserId.length && values.signByUserId.indexOf(userId) != -1}
                title="Authenticate File" className="text-center btn btn-dark btn-sm m-1" onClick={
                  () => callAclAuthComponent(values)}>
                <i class="fas fa-file-signature"></i>
              </button>}

          </td>
        </tr>)
      }) : ''
      return (exhibitDocElements)
    }

    if (type == 'NOA') {
      let NOADocElements = data.NOADocList.length ? data.NOADocList.map((values, index) => {
        // console.log("value in doc render =>", values)

        values.reqId = data.id
        values.tbl_doc_id = values.id
        values.document_name = values.doc_name
        values.uploaded_by = values.createdBy
        values.uploaded_on = values.created_at
        values.signType = 'withoutBlockChain'
        values.type = 'OTPVerification'

        return (<tr>
          <td>{1}</td>
          <td>{(values && values.doc_name) ? values.doc_name : 'NA'}</td>
          <td>{(values && values.createdBy) ? values.createdBy : 'NA'}</td>
          <td>{(values && values.created_at) ? formatDate_Application(values.created_at) : 'NA'}</td>
          <td>
            {(values && values.sign) ? <pre><span className="text-success mr-1">{values.sign.map((signV) => { return (<><i className="fa fa-certificate" /> {signV}<br /></>) })}</span></pre> : ''}
          </td>
          <td className="row justify-content-center  mt-0 pt-0 m-0 ">

            <button title="View File" className="text-center btn btn-primary btn-sm m-1" onClick={
              () => callPreviewFileComponent(values, "view")}>
              <i className="fa fa-eye" aria-hidden="true"></i>
            </button>
            <button title="Download File" className="text-center btn btn-primary btn-sm m-1" onClick={
              () => callPreviewFileComponent(values, "download")}>
              <i className="fa fa-download" aria-hidden="true"></i>
            </button>
            {userTypeId == 4 || userTypeId == 14 &&
              <button
                disabled={values.signByUserId && values.signByUserId.length && values.signByUserId.indexOf(userId) != -1}
                title="Authenticate File" className="text-center btn btn-dark btn-sm m-1" onClick={
                  () => callAclAuthComponent(values)}>
                <i class="fas fa-file-signature"></i>
              </button>}

          </td>
        </tr>)
      }) : ''
      return (NOADocElements)
    }

    if (type == 'Framework') {
      let FrameworkDocElements = data.frameworkDocList.length ? data.frameworkDocList.map((values, index) => {

        if (values.lendername == data.lenderName) {

          console.log("value in doc render hhhhhhhhhhhhhhhhhhhh =>", values);
          let valueData = JSON.parse(values.frameworkDocList);

          valueData.reqId = data.id
          valueData.tbl_doc_id = valueData.id
          valueData.document_name = valueData.doc_name
          valueData.uploaded_by = values.lenderName
          valueData.uploaded_on = valueData.created_at
          valueData.signType = 'withoutBlockChain'

          return (<tr>
            <td>{1}</td>
            <td>{(valueData && valueData.doc_name) ? valueData.doc_name : 'NA'}</td>
            <td>{(data.lenderName) ? data.lenderName : 'NA'}</td>
            <td>{(valueData && valueData.created_at) ? formatDate_Application(valueData.created_at) : 'NA'}</td>
            <td>
              {(valueData && valueData.sign) ? <pre><span className="text-success mr-1">{valueData.sign.map((signV) => { return (<><i className="fa fa-certificate" /> {signV}<br /></>) })}</span></pre> : ''}
            </td>
            <td className="row justify-content-center  mt-0 pt-0 m-0 ">

              <button title="View File" className="text-center btn btn-primary btn-sm m-1" onClick={
                () => callPreviewFileComponent(valueData, "view")}>
                <i className="fa fa-eye" aria-hidden="true"></i>
              </button>
              <button title="Download File" className="text-center btn btn-primary btn-sm m-1" onClick={
                () => callPreviewFileComponent(valueData, "download")}>
                <i className="fa fa-download" aria-hidden="true"></i>
              </button>
              {userTypeId == 4 || userTypeId == 14 &&
                <button title="Authenticate File" className="text-center btn btn-dark btn-sm m-1" onClick={
                  () => callAclAuthComponent(valueData)}>
                  <i class="fas fa-file-signature"></i>
                </button>}

            </td>
          </tr>)
        }
      })
        : ''
      return (FrameworkDocElements)
    }

  }

  function toolTip(inputName) {
    return (
      <span className="help-icon" flow="right" tooltip={toolTipText[inputName]}>i</span>
    )
  }

  function callPreviewFileComponent(values, action) {
    setfileData({ tbl_doc_id: values.id, "action": action })
    setshowPreviewModal(true)
  }

  function callAclAuthComponent(values) {
    console.log("in acl call ", values);
    setfileData({ ...values })
    setAclAuthModal(true);
  }

  function updateDocument(event, type) {

    let formData = new FormData();
    formData.append('id', data.id);
    formData.append('finType', 2);
    formData.append('uploadType', type);
    formData.append(type == 'Exhibit' ? 'ExhibitDocument' : 'NOADocument', event.target.files[0]);
    call('POST', 'uploadFinAgreement', formData).then((result) => {
      if (result) {
        toastDisplay("File Uploaded", "success");
        setrefresh(refresh + 1);
        setshowLoader(false)
      }
    }).catch(err => {
      console.log("conn:", err)
      toastDisplay(err.message, "error");
      setshowLoader(false)
    })
  }
  //---------------------------------------------------------------------------------------------------------------------

  const submitLCFinanceForm = (event) => {

    setshowLoader(true)
    const currentRoute = "applyLCFinance"
    data.sellerId = userId

    if (file.lcDocument) {
      data["lcDocumentMetadata"] = JSON.stringify({
        "docNo": data.referenceNo,
        "docName": 'LC Document',
        "genDocLabel": "lcDocument",
        "docType": 17,
        "category": 3,
        "validUpto": data.lcDocumentMM + "/" + data.lcDocumentYY
      })
      delete data.lcDocumentMM
      delete data.lcDocumentYY
    }
    if (file.invReportDocument) {
      data["invReportDocumentMetadata"] = JSON.stringify({
        "docNo": 'Investigation Report',
        "docName": 'Investigation Report',
        "genDocLabel": "invReportDocument",
        "docType": 6,
        "category": 5,
        "validUpto": data.invReportDocumentMM + "/" + data.invReportDocumentYY
      })
      delete data.invReportDocumentMM
      delete data.invReportDocumentYY
    }
    if (file.logisticDocument) {
      data["logisticDocumentMetadata"] = JSON.stringify({
        "docNo": 'Shipment Document',
        "docName": 'Shipment Document',
        "genDocLabel": "logisticDocument",
        "docType": 25,
        "category": 8,
        "validUpto": data.logisticDocumentMM + "/" + data.logisticDocumentYY
      })
      delete data.logisticDocumentMM
      delete data.logisticDocumentYY
    }
    if (file.grnDocument) {
      data["grnDocumentMetadata"] = JSON.stringify({
        "docNo": 'GRN Document',
        "docName": 'GRN Document',
        "genDocLabel": "grnDocument",
        "docType": 24,
        "category": 8,
        "validUpto": data.grnDocumentMM + "/" + data.grnDocumentYY
      })
      delete data.grnDocumentMM
      delete data.grnDocumentYY
    }


    data.otherDocMetaData = data.otherDocMetaData ? JSON.stringify(data.otherDocMetaData) : null
    data.baseUrl = config.baseUrl;
    data.applicantName = userName;

    // console.log("final data going in req body==>", data)

    let formData = new FormData();

    let tempOffline = { buyer_type: buyerType }
    if (data.buyerId === "ME") {
      // tempOffline = { ...tempOffline, buyer_name: data.buyerNameManual, buyer_addr: data.buyerAddrManual }
      tempOffline = { ...tempOffline, buyer_name: data.buyerNameManual }
    }
    if (data.logisticName == "Others") {
      tempOffline = { ...tempOffline, logistic_name: data.logisticNameManual }
    }
    formData.append("offline_data", JSON.stringify(tempOffline));

    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    })
    Object.keys(file).forEach((key) => {
      formData.append(key, file[key]);
    })

    call("post", currentRoute, formData)
      .then((result) => {
        setshowLoader(false)
        toastDisplay("Loan Applied successfuly", "success");
        ClearCache("lc_form_data")
        setFinanceDetails(false, 0, 0, {})
      })
      .catch((e) => {
        setshowLoader(false)
        toastDisplay(e, "error");
        console.log("error in create finance modal", e);
      });
  };

  // Accept Po Discounting Call
  function acceptLCDiscounting(party) {
    call("POST", "acceptLC", { party: userTypeId, id: data.id, manualUserEmail: userEmail })
      .then((result) => {
        toastDisplay("Request Accepted successfuly", "success");
        setFinanceDetails(false, 0, 0, {})
      })
      .catch((e) => {
        toastDisplay(e, "error");
        console.log("error in acceptPO", e);
      });
  }

  // Update Finance form
  function updateDiscounting() {

    setshowLoader(true)
    delete data.doc
    console.log('data updateLCFinance==>', data);
    console.log('file updateLCFinance=>', file);

    data.otherDocMetaData = data.otherDocMetaData ? JSON.stringify(data.otherDocMetaData) : null

    let formData = new FormData();

    formData.append("id", data.id);
    formData.append("reqAmount", data.reqAmount);
    formData.append("creditDays", data.creditDays);
    formData.append("interestRate", data.interestRate);
    formData.append("fintnc", data.fintnc);
    formData.append("otherDocMetaData", data.otherDocMetaData);
    formData.append("sellerId", data.sellerId);
    formData.append("lenderId", data.lenderId);
    formData.append("buyerId", data.buyerId);

    Object.keys(file).forEach((key) => {
      formData.append(key, file[key]);
    })

    call("POST", "updateLCFinance", formData)
      .then((result) => {
        setshowLoader(false)
        toastDisplay("Discounting Updated successfuly", "success");
        setFinanceDetails(false, 0, 0, {})
      })
      .catch((e) => {
        setshowLoader(false)
        toastDisplay(e, "error");
        console.log("error in updateLCFinance", e);
      });
  }

  const NavigationButtons = ({ showNextButton }) => {
    return (
      <div className="col-md-12">
        {(financeDetails.type === 2 && ((tab === 0 && showNextButton) || financeDetails.page < 2)) ?
          <button type="button" className="btn btn-success btn-sm float-right" onClick={() => { prehandleForward() }}>
            Next<i className="fa fa-chevron-right pl-2" aria-hidden="true"></i>
          </button> :

          data.sellerStatus === 2 && data.lenderStatus === 2 ?
            <button type="button" className="btn btn-success btn-sm border border-success float-right" disabled>
              <b> Approved </b> <i class="fa fa-check-circle-o" aria-hidden="true"></i>
            </button> :

            ((data.sellerStatus === 2 && data.sellerId === userId && data.lenderStatus === 1) || (data.sellerStatus === 1 && data.lenderId === userId && data.lenderStatus === 2)) ?
              <button type="button" className="btn btn-warning btn-sm border border-warning float-right mr-2" disabled>
                <b> Approved By You</b> <i class="fa fa-check-circle-o" aria-hidden="true"></i>
              </button> :

              ((data.sellerStatus === 1 && data.sellerId === userId && data.status === 3 && userTypeId != 20) || (data.lenderStatus === 1 && data.lenderId === userId && data.status === 3 && data.sellerStatus === 2 && userTypeId != 20)) ?
                <>
                  {(amount / 1 === data.reqAmount / 1) &&
                    <button type="button" className="btn btn-warning btn-sm border border-warning float-right mr-2" onClick={() => acceptLCDiscounting()}>
                      <b> Approve </b><i class="fa fa-check-circle-o" aria-hidden="true"></i>
                    </button>}
                  {(data.sellerStatus === 1 && data.lenderStatus === 1) &&
                    <button type="button" className="btn btn-success btn-sm border border-success float-right  mr-2" onClick={updateDiscounting}>
                      <b> Update </b> <i class="fa fa-check-circle-o" aria-hidden="true"></i>
                    </button>}
                </> :

                ((data.sellerStatus === 1 && data.lenderStatus === 1) && financeDetails.info.action === "viewFinance" && data.sellerId === userId && userTypeId != 20) ?
                  <button type="button" className="btn btn-success btn-sm border border-success float-right" onClick={updateDiscounting}>
                    <b> Update </b> <i class="fa fa-check-circle-o" aria-hidden="true"></i>
                  </button> :

                  ((data.sellerStatus === 1 && data.lenderStatus === 1) && financeDetails.info.action === "viewFinance" && data.lenderId === userId && userTypeId != 20) ?
                    <button type="button" className="btn btn-success btn-sm border border-success float-right" onClick={updateDiscounting}>
                      <b> Send Offer </b> <i class="fa fa-check-circle-o" aria-hidden="true"></i>
                    </button> :

                    (userTypeId != 20 &&
                      <button type="button" className="btn btn-success btn-sm border border-success float-right" onClick={submitLCFinanceForm} disabled={data.dnc === "on" ? false : true} > <b> Apply </b>
                        <i class="fa fa-check-circle-o" aria-hidden="true"></i>
                      </button>)}

        {(financeDetails.type === 2 && financeDetails.page > 0) &&
          <button type="button" className="btn btn-danger btn-sm float-left" onClick={() => { tab === 1 ? setTab(0) : backward() }}>
            <i className="fa fa-chevron-left pr-2" aria-hidden="true"></i>Back
          </button>}
      </div>
    )
  }

  //---------------------------------------------------------------------------------------------------------------------


  // JSX return
  return (
    <>
      {showLoader === true && (<div className="loading-overlay"><span><img className="" src="assets/images/loader.gif" alt="description" /></span></div>)}
      {(financeDetails.status && financeDetails.type === 2 && financeDetails.page === 1) ?
        <>
          <ul className="nav nav-tabs-custom" id="myTab" role="tablist">
            <li>
              <a className={"nav-link pl-4 pr-4 cursor-pointer " + (tab === 0 ? " active show" : "")} onClick={() => {
                setTab(0);
              }}>Application Details</a>
            </li>
            <li>
              <a className={"nav-link pl-4 pr-4 cursor-pointer " + (tab === 1 ? " active show" : "")} onClick={() => {
                setTab(1);
              }}>Documents</a>
            </li>
          </ul>
          <div className="col-md-12 shadow bg-light pt-2 pb-5">
            {tab === 0 ? (
              <div className="row">

                <div className="col-md-6">
                  <div className="row form-group">
                    <label className="col-md-12">Applicant  {astrix} {toolTip('buyerId')}</label>
                    <div className="col-md-12">
                      <input type="text" className={"form-control" + (error.applicantEmail ? " border-danger" : "")} name="applicant" value={data.applicantEmail} readOnly />
                      {error.applicantEmail ? <div class="text-danger error-contract">{error.applicantEmail}</div> : ''}
                    </div>
                  </div>
                </div>

                <div className="col-md-2">
                  <div className="row form-group">
                    <label className="col-md-12">Data Line {toolTip('dirDataLine')}</label>
                    <div className="col-md-12">
                      <select className="form-control" name="buyerType" value={buyerType} onChange={(event) => {
                        setBuyerType(event.target.value / 1)
                      }} disabled={financeDetails.info.action === "applyFinance" ? false : true}>
                        <option value="1" selected>Network</option>
                        <option value="2">Directory</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="row form-group">
                    <label className="col-md-12">Select Buyer {astrix}  {toolTip('buyerId')}</label>
                    <div className="col-md-12">
                      <select className={"form-control" + (error.buyerId ? " border-danger" : "")} name="buyerId" value={data.buyerId + ":" + data.buyerName + ':' + data.buyerEmail} onChange={handleChange} disabled={financeDetails.info.action === "viewFinance"}>
                        <option value="" selected>--Select Buyer--</option>
                        {userTypeId != 19 &&
                          <optgroup label="My Buyers">
                            {counterPart.length > 0 ? counterPart.map((counter) => {
                              return (
                                <option value={counter.id + ':' + counter.buyerName + ':' + counter.buyerEmail} >{counter.buyerName}</option>
                              )
                            })
                              :
                              <option disabled>Not Available</option>}
                          </optgroup>}
                        <optgroup label="Public Buyer">
                          {buyerArr.length > 0 ? buyerArr.map((buyer) => {
                            return (
                              <option value={buyer.id + ':' + buyer.company_name + ':' + buyer.user_name} >{buyer.company_name}</option>
                            )
                          })
                            :
                            <option disabled>Not Available</option>}
                        </optgroup>
                        <optgroup label="Others">
                          <option value="ME:Other:other_buyer">Other</option>
                        </optgroup>
                      </select>
                      {error.buyerId ? <div class="text-danger error-contract">{error.buyerId}</div> : ''}
                    </div>
                  </div>
                </div>

                {(data.buyerId === "ME") && <>
                  <div className="col-md-6">
                    <div className="row form-group">
                      <label className="col-md-12">Buyer Name (Manual Entry) {astrix} {toolTip('buyerName')}</label>
                      <div className="col-md-12">
                        <input type="text" className="form-control" name="buyerNameManual" value={data.buyerNameManual} onChange={handleChange} readOnly={financeDetails.info.action === "viewFinance"} />
                        {error.buyerNameManual ? <div class="text-danger error-contract">{error.buyerNameManual}</div> : ''}
                      </div>
                    </div>
                  </div>

                  {/* <div className="col-md-6">
                    <div className="row form-group">
                      <label className="col-md-12">Buyer Address (Manual Entry) {astrix} {toolTip('buyerAddr')}</label>
                      <div className="col-md-12">
                        <input type="text" className="form-control" name="buyerAddrManual" value={data.buyerAddrManual} onChange={handleChange} readOnly={financeDetails.info.action === "viewFinance"} />
                        {error.buyerAddrManual ? <div class="text-danger error-contract">{error.buyerAddrManual}</div> : ''}
                      </div>
                    </div>
                  </div> */}
                </>}

                <div className="col-md-6">
                  <div className="row form-group">
                    <label className="col-md-12">LC No {astrix}  {toolTip('lcRefrenceNo')}</label>
                    <div className="col-md-12">
                      <input type="text" className={"form-control" + (error.referenceNo ? " border-danger" : "")} name="referenceNo" value={data.referenceNo} placeholder="Enter LC Refrence No" onChange={handleChange} disabled={financeDetails.info.action === "viewFinance"} />
                      {error.referenceNo ? <div class="text-danger error-contract">{error.referenceNo}</div> : ''}
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="row form-group">
                    <label className="col-md-12">LC Issue date {astrix}  {toolTip('lcIssueDate')}</label>
                    <div className="col-md-12">
                      <input type="date" name="issueDate" value={data.issueDate} className={"form-control" + (error.issueDate ? " border-danger" : "")} onChange={handleChange} disabled={financeDetails.info.action === "viewFinance"} />
                      {error.issueDate ? <div class="text-danger error-contract">{error.issueDate}</div> : ''}
                    </div>
                  </div>
                </div>

                <div className="col-md-2">
                  <div className="row form-group">
                    <label className="col-md-12">Currency  {astrix} {toolTip('loanCurrency')}</label>
                    <div className="col-md-12 ">
                      <select className={"form-control" + (error.currency ? " border-danger" : "")} name="currency" value={data.currency + ":" + data.currencyName} onChange={handleChange} disabled={financeDetails.info.action === "viewFinance"}>
                        <option value="" selected>--Select Currency--</option>
                        {currencyData.map((currency) => {
                          return (
                            <option value={currency.id + ':' + currency.name} >{currency.name + " ( " + currency.code + " )" + " ( " + currency.symbol + " )"}</option>
                          )
                        })}
                      </select>
                      {error.currency ? <div class="text-danger error-contract">{error.currency}</div> : ''}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="row form-group">
                    <label className="col-md-12">Contract Amount {astrix}  {toolTip('contractAmount')}</label>
                    <div className="col-md-12">
                      <input type="number" step="0.01" className={"form-control" + (error.contractAmount ? " border-danger" : "")} name="contractAmount" value={data.contractAmount} placeholder="Enter Contract Amount" onChange={handleChange} disabled={financeDetails.info.action === "viewFinance"} />
                      {error.contractAmount ? <div class="text-danger error-contract">{error.contractAmount}</div> : ''}
                    </div>
                  </div>
                </div>

                <div className="col-md-2">
                  <div className="row form-group">
                    <label className="col-md-12">Currency {astrix}  {toolTip('loanCurrency')}</label>
                    <div className="col-md-12 ">
                      <select className={"form-control" + (error.currency ? " border-danger" : "")} name="currency" value={data.currency + ":" + data.currencyName} disabled>
                        <option value="" selected>--Select Currency--</option>
                        {currencyData.map((currency) => {
                          return (
                            <option value={currency.id + ':' + currency.name}>{currency.name + " ( " + currency.code + " )" + " ( " + currency.symbol + " )"}</option>
                          )
                        })}
                      </select>
                      {error.currency ? <div class="text-danger error-contract">{error.currency}</div> : ''}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="row form-group">
                    <label className="col-md-12">Requested Amount {astrix}  {toolTip('loanAmount')}</label>
                    <div className="col-md-12">
                      <input type="number" step="0.01" className={"form-control" + (error.reqAmount ? " border-danger" : "")} name="reqAmount" value={data.reqAmount} placeholder="Enter Finance Amount" onChange={handleChange} disabled={data.sellerStatus === 1 && data.lenderStatus === 1 && userTypeId != 8} />
                      {error.reqAmount ? <div class="text-danger error-contract">{error.reqAmount}</div> : ''}
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="row form-group">
                    <label className="col-md-12">Select Lender  {astrix} {toolTip('lenderId')}</label>
                    <div className="col-md-12">
                      {financeDetails.info.action !== "viewFinance" ?
                        <select className={"form-control" + (error.lenderId ? " border-danger" : "")} name="lenderId" id="select_lenderId" value={data.lenderId + ':' + data.lenderName + ':' + data.lenderUniqueId} onChange={handleChange} disabled={financeDetails.info.action === "viewFinance"}>
                          <option value="">--Select Lender--</option>
                          {bankMaster.map((values) => {
                            return (<option value={values.id + ':' + values.company_name + ':' + values.email_id} >{values.company_name}</option>)
                          })}
                        </select>
                        :
                        <input type="text" name="lenderId" value={data.lenderName} className={"form-control" + (error.lenderId ? " border-danger" : "")} onChange={handleChange} disabled />}
                      <br />
                      {creditData.map((bank) => {
                        if (data.lenderUniqueId == bank.id) {
                          return (
                            <p>   Approved Finance Amount: {bank.approvedFinanceAmount}</p>
                          )
                        }
                      })
                      }
                      {error.lenderId ? <div class="text-danger error-contract">{error.lenderId}</div> : ''}
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="row form-group">
                    <label className="col-md-12">Interest Rate (<small>To be filled by Banker</small>){astrix}  {toolTip('interestRate')}</label>
                    <div className="col-md-12">
                      <input className={"form-control" + (error.interestRate ? " border-danger" : "")} type="number" name="interestRate" value={data.interestRate} placeholder="Enter Interest rate" onChange={handleChange} readOnly={userTypeId !== 8 || data.sellerStatus / 1 === 2} />
                      {error.interestRate ? <div class="text-danger error-contract"> {error.interestRate} </div> : ''}
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="row form-group">
                    <label className="col-md-12">Finance Credit Days {astrix}  {toolTip('loanCreditDays')}</label>
                    <div className="col-md-12">
                      <input className={"form-control" + (error.creditDays ? " border-danger" : "")} type="number" name="creditDays" value={data.creditDays} placeholder="Enter Finance Credit Days" onChange={handleChange} disabled={data.sellerStatus === 1 && data.lenderStatus === 1 && userTypeId != 8} />
                      {error.creditDays ? <div class="text-danger error-contract"> {error.creditDays} </div> : ''}
                    </div>
                  </div>
                </div>


                <div className="col-md-6">
                  <div className="row form-group">
                    <label className="col-md-12">Shipper/Broker {toolTip('logisticId')}</label>
                    <div className="col-md-12">
                      {financeDetails.info.action !== "viewFinance" ?
                        <select className={"form-control" + (error.logisticId ? " border-danger" : "")} name="logisticId" value={data.logisticId + ":" + data.logisticName} onChange={handleChange}>
                          <option value="" selected>--Select Shipper/Broker--</option>
                          {logiArr.map((logist) => {
                            return (
                              <option value={logist.id + ':' + logist.company_name} >{logist.company_name}</option>
                            )
                          })}
                          <option value="NULL:Others" selected>Others</option>
                        </select>
                        :
                        <input type="text" name="logisticId" value={data.logisticName == 'Not Available' ? data.logisticNameManual : data.logisticName} className={"form-control" + (error.logisticId ? " border-danger" : "")} onChange={handleChange} disabled />}
                      {error.logisticId ? <div class="text-danger error-contract">{error.logisticId}</div> : ''}
                    </div>
                  </div>
                </div>

                {data.logisticName == "Others" &&
                  <div className="col-md-6">
                    <div className="row form-group">
                      <label className="col-md-12">Shipper/Broker Name (Manual Entry) {astrix} {toolTip('logisticName')}</label>
                      <div className="col-md-12">
                        <input type="text" className="form-control" name="logisticNameManual" value={data.logisticNameManual} onChange={handleChange} readOnly={financeDetails.info.action === "viewFinance"} />
                        {error.logisticNameManual ? <div class="text-danger error-contract">{error.logisticNameManual}</div> : ''}
                      </div>
                    </div>
                  </div>
                }

                <div className="col-md-6">
                  <div className="row form-group">
                    <label className="col-md-12">GRN Date {astrix}  {toolTip('grnDate')}</label>
                    <div className="col-md-12">
                      <input type="date" name="grnDate" value={data.grnDate} className={"form-control" + (error.grnDate ? " border-danger" : "")} onChange={handleChange} disabled={financeDetails.info.action === "viewFinance"} />
                      {error.grnDate ? <div class="text-danger error-contract">{error.grnDate}</div> : ''}
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="row form-group">
                    <label className="col-md-12">Advising Bank {astrix}  {toolTip('advisingBank')}</label>
                    <div className="col-md-12">
                      <input type="text" name="advisingBank" value={data.advisingBank} className={"form-control" + (error.advisingBank ? " border-danger" : "")} onChange={handleChange} disabled={financeDetails.info.action === "viewFinance"} />
                      {error.advisingBank ? <div class="text-danger error-contract">{error.advisingBank}</div> : ''}
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="row form-group">
                    <label className="col-md-12">Confirming Bank {astrix}  {toolTip('confirmingBank')}</label>
                    <div className="col-md-12">
                      <input type="text" name="confirmingBank" value={data.confirmingBank} className={"form-control" + (error.confirmingBank ? " border-danger" : "")} onChange={handleChange} disabled={financeDetails.info.action === "viewFinance"} />
                      {error.confirmingBank ? <div class="text-danger error-contract">{error.confirmingBank}</div> : ''}
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="row form-group">
                    <label className="col-md-12">Due Date {astrix}  {toolTip('dueDate')}</label>
                    <div className="col-md-12">
                      <input type="date" name="dueDate" value={data.dueDate} className={"form-control" + (error.dueDate ? " border-danger" : "")} onChange={handleChange} disabled={financeDetails.info.action === "viewFinance"} />
                      {error.dueDate ? <div class="text-danger error-contract">{error.dueDate}</div> : ''}
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="row form-group">
                    <label className="col-md-12">Finance TNC (<small>To be filled by Banker</small>) {astrix}  {toolTip('fintnc')}</label>
                    <div className="col-md-12">
                      <textarea rows="4" className={"form-control" + (error.fintnc ? " border-danger" : "")} name="fintnc" value={data.fintnc} onChange={handleChange} readOnly={userTypeId !== 8 || data.sellerStatus / 1 === 2}></textarea>
                      {error.fintnc ? <div class="text-danger error-contract"> {error.fintnc} </div> : ''}
                    </div>
                  </div>
                </div>

                {creditData.map((bank) => {
                  if (data.lenderUniqueId == bank.id) {
                    return (
                      <div className={"accordionItem mt-3" + (accord['0'] ? " closed" : " open")}>
                        <h2 className="accordionItemHeading" onClick={() => setAccord({ ...accord, '0': !accord['0'] })}>Credit Line Details</h2>
                        <div className="accordionItemContent">
                          <div className="col-md-12 row">

                            <div className="col-md-6">
                              <div className="row form-group">
                                <label className="col-md-12">Requested Amount</label>
                                <div className="col-md-12">
                                  <input type="text" className={"form-control" + (error.dirContractNo ? " border-danger" : "")} name="dirContractNo" value={bank.credit_amount} readOnly={true} />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="row form-group">
                                <label className="col-md-12">Approved Finance Amount</label>
                                <div className="col-md-12">
                                  <input type="text" className={"form-control" + (error.dirContractNo ? " border-danger" : "")} name="dirContractNo" value={bank.approvedFinanceAmount} readOnly={true} />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="row form-group">
                                <label className="col-md-12">Funding Percentage</label>
                                <div className="col-md-12">
                                  <input type="text" className={"form-control" + (error.dirContractNo ? " border-danger" : "")} name="dirContractNo" value={bank.fundingPercentage + '%'} readOnly={true} />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="row form-group">
                                <label className="col-md-12">Funding Tenor</label>
                                <div className="col-md-12">
                                  <input type="text" className={"form-control" + (error.dirContractNo ? " border-danger" : "")} name="dirContractNo" value={bank.fundingTenor} readOnly={true} />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="row form-group">
                                <label className="col-md-12">Due Date Calculation From</label>
                                <div className="col-md-12">
                                  <input type="text" className={"form-control" + (error.dirContractNo ? " border-danger" : "")} name="dirContractNo" value={bank.duedateCalcFrom} readOnly={true} />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="row form-group">
                                <label className="col-md-12">Interest Rate</label>
                                <div className="col-md-12">
                                  <input type="text" className={"form-control" + (error.dirContractNo ? " border-danger" : "")} name="dirContractNo" value={bank.interestRate + '%'} readOnly={true} />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="row form-group">
                                <label className="col-md-12">Interest Collection</label>
                                <div className="col-md-12">
                                  <input type="text" className={"form-control" + (error.dirContractNo ? " border-danger" : "")} name="dirContractNo" value={bank.interestCollection} readOnly={true} />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="row form-group">
                                <label className="col-md-12">Finance Request Percentage</label>
                                <div className="col-md-12">
                                  <input type="text" className={"form-control" + (error.dirContractNo ? " border-danger" : "")} name="dirContractNo" value={bank.finRequestPercentage + '%'} readOnly={true} />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="row form-group">
                                <label className="col-md-12">Finance Request Collection</label>
                                <div className="col-md-12">
                                  <input type="text" className={"form-control" + (error.dirContractNo ? " border-danger" : "")} name="dirContractNo" value={bank.finRequestCollection} readOnly={true} />
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    )
                  }
                })
                }
              </div>
            ) : null}

            {tab === 1 ? (
              <>
                <div className="row">
                  {(financeDetails.info.action === "applyFinance") ?
                    <>
                      <div className="col-md-12">
                        <h3 className="pt-2 pb-2"><u>Supporting Documents</u></h3>
                        <div className="col-md-12 pt-2 pb-3">
                          <ul className="other-documents">
                            <li>
                              <span className="file-icon"><img src="../assets/images/onbording/file-icon.svg" /> </span>
                            </li>
                            <li>
                              <h3 className={"custum-control" + (error.lcDocument ? " border-danger" : "")} style={{ "min-width": "205px" }}>LC Document {astrix}  {toolTip('lcDocument')}</h3>
                            </li>
                            {/* <li>
                        <div className="document-name-top">Valid Upto </div>
                        <div className="document-name-bottom">(If applicable )</div>
                      </li> */}
                            {/* <li>
                        <input type="text" className="custum-control year" name={"lcDocumentMM"} value={data.lcDocumentMM} placeholder="MM" maxlength="2" onChange={handleChange} />
                        <input type="text" className="custum-control year" name={"lcDocumentYY"} value={data.lcDocumentYY} placeholder="YYYY" maxlength="4" onChange={handleChange} />
                      </li> */}
                            <li>
                              <div className="file-browse">
                                <button className="btn btn-primary btn-sm">Upload Document</button>
                                <input type="file" accept=".png,.jpg,.pdf" name="lcDocument" onChange={handleFiles} />
                              </div>
                            </li>
                            <li> </li>
                          </ul>
                          {file.lcDocument ? <div className="form-group mb-0"><div className="file-name">{`${file.lcDocument.name}`}</div></div> : ""}
                          {error.invoiceDocument ? <div class="text-danger error-contract">{error.invoiceDocument}</div> : ''}
                        </div>
                        <hr />
                        <div className="col-md-12 pt-2 pb-3">
                          <ul className="other-documents">
                            <li>
                              <span className="file-icon"><img src="../assets/images/onbording/file-icon.svg" /> </span>
                            </li>
                            <li>
                              <h3 className="custum-control" style={{ "min-width": "205px" }}>Investigation Report {toolTip('invReportDocument')}</h3>
                            </li>
                            {/* <li>
                        <div className="document-name-top">Valid Upto </div>
                        <div className="document-name-bottom">(If applicable )</div>
                      </li> */}
                            {/* <li>
                        <input type="text" className="custum-control year" name={"invReportDocumentMM"} value={data.invReportDocumentMM} placeholder="MM" max="2" onChange={handleChange} />
                        <input type="text" className="custum-control year" name={"invReportDocumentYY"} value={data.invReportDocumentYY} placeholder="YYYY" max="4" onChange={handleChange} />
                      </li> */}
                            <li>
                              <div className="file-browse">
                                <button className="btn btn-primary btn-sm">Upload Document</button>
                                <input type="file" accept=".png,.jpg,.pdf" name="invReportDocument" onChange={handleFiles} />
                              </div>
                            </li>
                            <li> </li>
                          </ul>
                          {file.invReportDocument ? <div className="form-group mb-0"><div className="file-name">{`${file.invReportDocument.name}`}</div></div> : ""}
                        </div>
                        <hr />
                        <div className="col-md-12 pt-2 pb-3">
                          <ul className="other-documents">
                            <li>
                              <span className="file-icon"><img src="../assets/images/onbording/file-icon.svg" /> </span>
                            </li>
                            <li>
                              <h3 className="custum-control" style={{ "min-width": "205px" }}>Shipment Document {toolTip('logisticDocument')}</h3>
                            </li>
                            {/* <li>
                        <div className="document-name-top">Valid Upto </div>
                        <div className="document-name-bottom">(If applicable )</div>
                      </li> */}
                            {/* <li>
                        <input type="text" className="custum-control year" name={"logisticDocumentMM"} value={data.logisticDocumentMM} placeholder="MM" maxlength="2" onChange={handleChange} />
                        <input type="text" className="custum-control year" name={"logisticDocumentYY"} value={data.logisticDocumentYY} placeholder="YYYY" maxlength="4" onChange={handleChange} />
                      </li> */}
                            <li>
                              <div className="file-browse">
                                <button className="btn btn-primary btn-sm">Upload Document</button>
                                <input type="file" accept=".png,.jpg,.pdf" name="logisticDocument" onChange={handleFiles} />
                              </div>
                            </li>
                            <li> </li>
                          </ul>
                          {file.logisticDocument ? <div className="form-group mb-0"><div className="file-name">{`${file.logisticDocument.name}`}</div></div> : ""}
                        </div>
                        <hr />
                        <div className="col-md-12 pt-2 pb-3">
                          <ul className="other-documents">
                            <li>
                              <span className="file-icon"><img src="../assets/images/onbording/file-icon.svg" /> </span>
                            </li>
                            <li>
                              <h3 className="custum-control" style={{ "min-width": "205px" }}>GRN Documnet {toolTip('grnDocument')}</h3>
                            </li>
                            {/* <li>
                        <div className="document-name-top">Valid Upto </div>
                        <div className="document-name-bottom">(If applicable )</div>
                      </li> */}
                            {/* <li>
                        <input type="text" className="custum-control year" name={"grnDocumentMM"} value={data.grnDocumentMM} placeholder="MM" maxlength="2" onChange={handleChange} />
                        <input type="text" className="custum-control year" name={"grnDocumentYY"} value={data.grnDocumentYY} placeholder="YYYY" maxlength="4" onChange={handleChange} />
                      </li> */}
                            <li>
                              <div className="file-browse">
                                <button className="btn btn-primary btn-sm">Upload Document</button>
                                <input type="file" accept=".png,.jpg,.pdf" name="grnDocument" onChange={handleFiles} />
                              </div>
                            </li>
                            <li> </li>
                          </ul>
                          {file.grnDocument ? <div className="form-group mb-0"><div className="file-name">{`${file.grnDocument.name}`}</div></div> : ""}
                        </div>
                      </div>
                    </> :
                    <>
                      <div class="col-md-12">
                        <div className={"accordionItem mt-3" + (accord['0'] ? " closed" : " open")}>
                          <h2 className="accordionItemHeading" onClick={() => setAccord({ ...accord, '0': !accord['0'] })}>Initial Documents</h2>
                          <div className="accordionItemContent">
                            <div className="col-md-12">
                              <div className="table-responsive" style={{ "min-height": "150px" }}>
                                <table className="table table-striped table-sm m-0" cellSpacing={0} cellPadding={0}>
                                  <thead>
                                    <tr>
                                      <th width="20">#</th>
                                      <th>Type of Document</th>
                                      <th width="200">Document Name</th>
                                      <th width="200">Uploaded By</th>
                                      <th width="200">Uploaded On</th>
                                      <th>Signed By</th>
                                      <th className="text-center" width="150">Actions</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {(data && data.doc && data.doc.length) && docPreviewGenerator(data.doc)}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div className={"accordionItem mt-3" + (accord['1'] ? " closed" : " open")}>
                          <h2 className="accordionItemHeading" onClick={() => setAccord({ ...accord, '1': !accord['1'] })}>Framework Agreement</h2>
                          <div className="accordionItemContent">
                            <div className="col-md-12">
                              <div className="table-responsive" style={{ "min-height": "150px" }}>
                                <table className="table table-striped table-sm m-0" cellSpacing={0} cellPadding={0}>
                                  <thead>
                                    <tr>
                                      <th width="20">#</th>
                                      <th width="200">Document Name</th>
                                      <th width="200">Uploaded By</th>
                                      <th width="200">Uploaded On</th>
                                      <th width="200">Signed By</th>
                                      <th className="text-center" width="150">Actions</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {(data.frameworkDocList && data.frameworkDocList.length) ? docAgreementPreview('Framework') : null}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div className={"accordionItem mt-3" + (accord['2'] ? " closed" : " open")}>
                          <h2 className="accordionItemHeading" onClick={() => setAccord({ ...accord, '2': !accord['2'] })}>Exhibit Agreement</h2>
                          <div className="accordionItemContent">
                            <div className="col-md-12">
                              <div className="table-responsive" style={{ "min-height": "150px" }}>
                                <table className="table table-striped table-sm m-0" cellSpacing={0} cellPadding={0}>
                                  <thead>
                                    <tr>
                                      <th width="20">#</th>
                                      <th width="200">Document Name</th>
                                      <th width="200">Uploaded By</th>
                                      <th width="200">Uploaded On</th>
                                      <th width="200">Signed By</th>
                                      <th className="text-center" width="150">Actions</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {(data && data.exhibitDocList && data.exhibitDocList.length) ? docAgreementPreview('Exhibit') : (data.status == 1 && userTypeId == 8) ? docUploadPreview('Exhibit') : ''}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div className={"accordionItem mt-3" + (accord['3'] ? " closed" : " open")}>
                          <h2 className="accordionItemHeading" onClick={() => setAccord({ ...accord, '3': !accord['3'] })}>Notice of Assignment</h2>
                          <div className="accordionItemContent">
                            <div className="col-md-12">
                              <div className="table-responsive" style={{ "min-height": "150px" }}>
                                <table className="table table-striped table-sm m-0" cellSpacing={0} cellPadding={0}>
                                  <thead>
                                    <tr>
                                      <th width="20">#</th>
                                      <th width="200">Document Name</th>
                                      <th width="200">Uploaded By</th>
                                      <th width="200">Uploaded On</th>
                                      <th width="200">Signed By</th>
                                      <th className="text-center" width="150">Actions</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {(data && data.NOADocList && data.NOADocList.length) ? docAgreementPreview('NOA') : (data.exhibitStatus == 1 && (data.status == 2 || data.status == 3) && userTypeId == 8) ? docUploadPreview('NOA') : ''}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  }
                </div>
                <hr />
                <OtherDocs
                  data={data}
                  setData={setData}
                  file={file}
                  handleFiles={handleFiles}
                  docLimit={2}
                />
              </>
            ) : null}
            <hr />
            <NavigationButtons showNextButton={true} />
          </div>
        </> :
        (financeDetails.status && financeDetails.type === 2 && financeDetails.page === 2) ?
          <>
            {/* <ul className="nav nav-tabs-custom" id="myTab" role="tablist">
              <li>
                <a className={"nav-link pl-4 pr-4 cursor-pointer " + (tab === 0 ? " active show" : "")} onClick={() => {
                  setTab(0);
                }}>Application Details</a>
              </li>
              <li>
                <a className={"nav-link pl-4 pr-4 cursor-pointer " + (tab === 1 ? " active show" : "")} onClick={() => {
                  setTab(1);
                }}>Documents</a>
              </li>
            </ul> */}
            <div class="col-md-12 p-2">
              <h1 className="text-center"><u>Finance against LC Form- Review</u></h1><br />
              <div className="row m-2">
                {/* {tab === 0 ? ( */}
                <>
                  <div class="col-md-2 p-2">
                    <label>Applicant</label>
                  </div>
                  <div class="col-md-4 p-2">
                    <input type="text" class="form-control" value={data.applicantEmail} disabled />
                  </div>
                  <div class="col-md-2 p-2">
                    <label>Buyer</label>
                  </div>
                  <div class="col-md-4 p-2">
                    <input type="text" class="form-control" value={data.buyerNameManual ? data.buyerNameManual : data.buyerName} disabled />
                  </div>
                  <div class="col-md-2 p-2">
                    <label>LC No</label>
                  </div>
                  <div class="col-md-4 p-2">
                    <input type="text" class="form-control" value={data.referenceNo} disabled />
                  </div>
                  <div class="col-md-2 p-2">
                    <label>LC Issue date</label>
                  </div>
                  <div class="col-md-4 p-2">
                    <input type="text" class="form-control" value={data.issueDate} disabled />
                  </div>
                  <div class="col-md-2 p-2">
                    <label>Currency</label>
                  </div>
                  <div class="col-md-4 p-2">
                    <input type="text" class="form-control" value={data.currencyName} disabled />
                  </div>
                  <div class="col-md-2 p-2">
                    <label>Contract Amount</label>
                  </div>
                  <div class="col-md-4 p-2">
                    <input type="text" class="form-control" value={data.contractAmount} disabled />
                  </div>
                  <div class="col-md-2 p-2">
                    <label>Currency</label>
                  </div>
                  <div class="col-md-4 p-2">
                    <input type="text" class="form-control" value={data.currencyName} disabled />
                  </div>
                  <div class="col-md-2 p-2">
                    <label>Requested Amount</label>
                  </div>
                  <div class="col-md-4 p-2">
                    <input type="text" class="form-control" value={data.reqAmount} disabled />
                  </div>
                  <div class="col-md-2 p-2">
                    <label>Lender</label>
                  </div>
                  <div class="col-md-4 p-2">
                    <input type="text" class="form-control" value={data.lenderName} disabled />
                  </div>
                  <div class="col-md-2 p-2">
                    <label>Interest Rate</label>
                  </div>
                  <div class="col-md-4 p-2">
                    <input type="text" class="form-control" value={data.interestRate} disabled />
                  </div>
                  <div class="col-md-2 p-2">
                    <label>Credit Days</label>
                  </div>
                  <div class="col-md-4 p-2">
                    <input type="text" class="form-control" value={data.creditDays} disabled />
                  </div>
                  <div class="col-md-2 p-2">
                    <label>Shipper/Broker</label>
                  </div>
                  <div class="col-md-4 p-2">
                    <input type="text" class="form-control" value={data.logisticName == "Others" ? data.logisticNameManual : data.logisticName} disabled />
                  </div>
                  <div class="col-md-2 p-2">
                    <label>GRN Date</label>
                  </div>
                  <div class="col-md-4 p-2">
                    <input type="text" class="form-control" value={data.grnDate} disabled />
                  </div>
                  <div class="col-md-2 p-2">
                    <label>Advising Bank</label>
                  </div>
                  <div class="col-md-4 p-2">
                    <input type="text" class="form-control" value={data.advisingBank} disabled />
                  </div>
                  <div class="col-md-2 p-2">
                    <label>Confirming Bank</label>
                  </div>
                  <div class="col-md-4 p-2">
                    <input type="text" class="form-control" value={data.confirmingBank} disabled />
                  </div>
                  <div class="col-md-2 p-2">
                    <label>Due Date</label>
                  </div>
                  <div class="col-md-4 p-2">
                    <input type="text" class="form-control" value={data.dueDate} disabled />
                  </div>
                </>
                {/* ) : null} */}
                <div>
                  <div className="row form-group">
                    {/* {financeDetails.info.action === "viewFinance" && tab === 1 && */}
                    {financeDetails.info.action === "viewFinance" &&
                      <>
                        <div className="col-md-12">
                          <div className="col-md-12 mt-3">
                            <h3 className="pt-2 pb-2"><u>Initial Documents</u></h3>
                            <div className="table-responsive" style={{ "min-height": "150px" }}>
                              <table className="table table-striped table-sm m-0" cellSpacing={0} cellPadding={0}>
                                <thead>
                                  <tr>
                                    <th width="20">#</th>
                                    <th>Type of Document</th>
                                    <th width="200">Document Name</th>
                                    <th width="200">Uploaded By</th>
                                    <th width="150">Uploaded On</th>
                                    <th>Signed By</th>
                                    <th className="text-center" width="150">Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {(data && data.doc && data.doc.length > 0) && docPreviewGenerator(data.doc)}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="col-md-12 mt-3">
                            <h3 className="pt-2 pb-2"><u>Framework Agreement</u></h3>
                            <div className="table-responsive" style={{ "min-height": "150px" }}>
                              <table className="table table-striped table-sm m-0" cellSpacing={0} cellPadding={0}>
                                <thead>
                                  <tr>
                                    <th width="20">#</th>
                                    <th width="200">Document Name</th>
                                    <th width="200">Uploaded By</th>
                                    <th width="150">Uploaded On</th>
                                    <th>Signed By</th>
                                    <th className="text-center" width="150">Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {(data.frameworkDocList && data.frameworkDocList.length) ? docAgreementPreview('Framework') : null}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="col-md-12 mt-3">
                            <h3 className="pt-2 pb-2"><u>Exhibit Agreement</u></h3>
                            <div className="table-responsive" style={{ "min-height": "150px" }}>
                              <table className="table table-striped table-sm m-0" cellSpacing={0} cellPadding={0}>
                                <thead>
                                  <tr>
                                    <th width="20">#</th>
                                    <th width="200">Document Name</th>
                                    <th width="200">Uploaded By</th>
                                    <th width="150">Uploaded On</th>
                                    <th>Signed By</th>
                                    <th className="text-center" width="150">Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {(data && data.exhibitDocList && data.exhibitDocList.length) ? docAgreementPreview('Exhibit') : (data.status == 1 && userTypeId == 8) ? docUploadPreview('Exhibit') : ''}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="col-md-12 mt-3">
                            <h3 className="pt-2 pb-2"><u>Notice of Assignment</u></h3>
                            <div className="table-responsive" style={{ "min-height": "150px" }}>
                              <table className="table table-striped table-sm m-0" cellSpacing={0} cellPadding={0}>
                                <thead>
                                  <tr>
                                    <th width="20">#</th>
                                    <th width="200">Document Name</th>
                                    <th width="200">Uploaded By</th>
                                    <th width="150">Uploaded On</th>
                                    <th>Signed By</th>
                                    <th className="text-center" width="150">Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {(data && data.NOADocList && data.NOADocList.length) ? docAgreementPreview('NOA') : (data.exhibitStatus == 1 && (data.status == 2 || data.status == 3) && userTypeId == 8) ? docUploadPreview('NOA') : ''}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </>
                    }

                    {/* {tab === 1 && (file && Object.keys(file).length > 0) && */}
                    {(file && Object.keys(file).length > 0) &&
                      <div className="col-md-12 row mt-3">

                        <h3 className="pt-2 pb-2 col-md-12 "><u>Added Documents</u></h3>
                        <div className="col-md-6">
                          <h3 className="col-md-12 pl-0 ml-0"><u>Document Name</u></h3>
                        </div>
                        <div className="col-md-6">
                          <h3 className="col-md-12  pl-0 ml-0"><u>File Name</u></h3>
                        </div>

                        {file && Object.keys(file).length ? Object.keys(file).map((doc) => {
                          return (
                            <>
                              <div className="col-md-6">
                                <div className="row form-group">
                                  <label className="col-md-12">{doc.toUpperCase() || '--'}</label>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="row form-group">
                                  <label className="col-md-12 text-primary">{file[doc].name}</label>
                                </div>
                              </div>
                            </>
                          )
                        }) : ''}
                      </div>}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 pt-3">
              <input type="checkbox" id="checkDNC" name="dnc" value="on" onChange={handleChange} required checked={data.dnc === "on" ? true : false} />
              <label className="checkbox-smallLabel width-auto" for="checkDNC">
                <span>
                  I hereby declare that the given information by me is best in my
                  knowledge and I did not apply any loan against this contract.
                </span>
              </label>
            </div>
          </> : "oops something is wrong , your were not supposed to get here."
      }

      {showPreviewModal && <FilePreview
        userTokenDetails={userTokenDetails}
        fileData={fileData}
        showPreviewModal={showPreviewModal}
        setshowPreviewModal={setshowPreviewModal}
      />}

      {showAclAuthModal &&
        <DigitalSignDoc
          userTokenDetails={userTokenDetails}
          fileData={fileData}
          showAclAuthModal={showAclAuthModal}
          setAclAuthModal={setAclAuthModal}
          refreshDoc={refresh}
          setrefreshDoc={setrefresh} />}

      {financeDetails.page === 2 ? (
        <>
          <hr className="pt-2 pb-2 text-primary" />
          <NavigationButtons showNextButton={false} />
        </>
      ) : null}
    </>
  );
};


//---------------------------------------------------------------------------------------------------------------------
// Redux
const mapStateToProps = state => {
  return {
    channelPartnerRaisedInvoice: state.channelPartnerRaisedInvoice,
    financeDetails: state.financeDetails,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setChannelPartnerRaisedInvoice: (modal, info) => { dispatch(setChannelPartnerRaisedInvoice({ modal: modal, info: info })) },
    setFinanceDetails: (status, type, page, info) => { dispatch(setFinanceDetails({ status: status, type: type, page: page, info: info })) },
  }
}
//---------------------------------------------------------------------------------------------------------------------

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LCFinance)
